import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { TextLoader } from "components/apiHandling/TextLoader";

interface BoxLoaderProps {
  messageKey?: string;
}

export function BoxLoader(props: any): JSX.Element {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} >
        <CircularProgress />
        <TextLoader messageKey={props.messageKey} />
      </Box>
    </Box>
  );
}